import { useEffect, useState } from "react";
import { Button, Col, Container, ListGroup, Modal, Row } from "react-bootstrap";
import { createOrUpdateProduct, getLibroProducts, getMembershipProducts } from "../../controllers/products";
import ProductForm from "./productForm";

function Products() {
  const [libros, setLibros] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [editarId, setEditarId] = useState();
  const [showNewProduct, setShowNewProduct] = useState(false);

  useEffect(() => {
    document.title = 'FAMA - Productos'
    loadProducts();
  }, []);

  async function loadProducts() {
    const memberships = await getMembershipProducts('raw');
    const libros = await getLibroProducts('raw');
    setMemberships(memberships);
    setLibros(libros);
  }

  async function onSubmitProduct(productData) {
    console.log('submit product', productData);
    try {
      await createOrUpdateProduct(productData);
    } catch (error) {
      console.error('Error creating or updating product:', error);
    }
    setShowNewProduct(false);
    setEditarId();
    loadProducts();
  }

  const renderProducts = (products) => {
    return <>
      <table className="d-none d-lg-table">
        <thead>
          <tr>
            <td>ID</td>
            <td>Nombre</td>
            <td>Descripción</td>
            <td>Tipo</td>
            <td>Precio</td>
            <td>Tipo de Perfil</td>
            <td>Etapa</td>
            <td>Activo</td>
            <td>Stripe Product ID</td>
            <td>Stripe Price ID</td>
            <td>Acciones</td>
          </tr>
        </thead>
        <tbody>
          {
            products.length > 0 && products.map((product, i) => {
              return <>
                <tr key={'product-' + product.product_id}>
                  <td>{product.product_id}</td>
                  <td>{product.product_name}</td>
                  <td>{product.product_description}</td>
                  <td>{product.product_type}</td>
                  <td>{product.price}</td>
                  <td>{product.profile_type?.label}</td>
                  <td>{product.etapa?.title}</td>
                  <td>{product.active ? 'Sí' : 'No'}</td>
                  <td>{product.stripe_product_id}</td>
                  <td>{product.stripe_price_id}</td>
                  <td>
                    <a onClick={e => {e.preventDefault(); setEditarId(product.product_id); setShowNewProduct(true);}} href="#">Editar</a>
                  </td>
                </tr>
              </>
            })
          }
        </tbody>
      </table>
      <ListGroup className="d-lg-none">
        {
          products.length > 0 && products.map((product, i) => {
            return <ListGroup.Item key={'product-' + product.product_id}>
              <p><strong>{product.product_name}</strong></p>
              <p>{product.product_description}</p>
              <p>Precio: ${product.price}</p>
              <p>Tipo de perfil: {product.profile_type?.label}</p>
              <p>Etapa: {product.etapa?.title}</p>
              <p>Activo: {product.active ? 'Sí' : 'No'}</p>
              <Button size="sm" onClick={e => {e.preventDefault(); setEditarId(product.product_id); setShowNewProduct(true);}} className="me-2">Editar</Button>
            </ListGroup.Item>
          })
        }
      </ListGroup>
    </>;
  }

  return (
    <Container className="products">
      <h1>Productos</h1>
      <p>Administración de membresías, libros y otros productos.</p>
      <Row>
        <Col style={{textAlign: 'right'}}>
          <Button onClick={e => setShowNewProduct(true)} className="me-4">Crear Nuevo Producto</Button>
        </Col>
      </Row>
      <h2>Membresías</h2>
      <Container>
        { renderProducts(memberships) }
      </Container>
      <h2 className="mt-5">Libros</h2>
      <Container style={{ overflowX: 'scroll'}}>
        { renderProducts(libros) }
      </Container>

      <Modal show={showNewProduct} size="xl" centered>
        <Modal.Header>{editarId ? 'Editar producto' : 'Capturar nuevo producto'}</Modal.Header>
        <Modal.Body>
          {editarId && <ProductForm {...libros.find(l => l.product_id === editarId) || memberships.find(m => m.product_id === editarId)} onSubmit={onSubmitProduct} cancel={() => {setEditarId(); setShowNewProduct(false);}} key={`producto-editar-${editarId}`} />}
          {!editarId && <ProductForm onSubmit={onSubmitProduct} cancel={() => setShowNewProduct(false)} key={`producto-nuevo-${libros.length + memberships.length}`} />}
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Products;